import { COMMON_EVENT_NAMES } from "../../constants";

export const EVENT_NAME = {
  SAVE_CHANGES: "Save Changes",
  NAVIGATE_MORE_PAGE: COMMON_EVENT_NAMES.NAVIGATED
};
